import { useInfiniteQuery } from "@tanstack/react-query";
import { authorizationService } from "../services/authorizationService";
import { AuthorizationStatusEnum } from "../services/authorizationService/getAuthorization";
import { PartnerType } from "../utils/partners.enum";

export type AuthorizationFilters = {
  search?: string;
  status?: AuthorizationStatusEnum[];
  type?: PartnerType[];
};

export const useAuthorizations = (filters?: AuthorizationFilters) => {
  return useInfiniteQuery({
    queryKey: ["authorizations", filters],
    initialPageParam: 0,

    queryFn: ({ pageParam }) =>
      authorizationService.getAuthorization({
        skip: pageParam,
        limit: 30,
        search: filters?.search || undefined,
        status: filters?.status,
        type: filters?.type,
      }),

    getNextPageParam: (lastPage) => {
      const nextSkip = lastPage.pagination.skip + lastPage.pagination.limit;

      if (nextSkip >= lastPage.pagination.total) {
        return undefined;
      }

      return nextSkip;
    },
  });
};
